import { firestoreAction } from "vuexfire";
import "firebase/firestore";
import { db } from "@/services/firebase.service";
import isEmpty from "lodash/isEmpty";
import store from "@/store";

export default {
    createEntreprise({ commit }, entreprise) {
        commit("CREATE_ENTREPRISE", entreprise);
    },
    creatProject({ commit }, project) {
        commit("CREATE_PROJECT", project);
    },
    addOffer({ commit }, offer) {
        commit("ADD_OFFER", offer);
    },
    removeOffer({ commit }, id) {
        commit("REMOVE_OFFER", id);
    },
    createClient({ commit }, client) {
        commit("CREATE_CLIENT", client);
    },
    removeClient({ commit }, id) {
        commit("REMOVE_CLIENT", id);
    },

    putEntreprisesData({ commit }, entreprises) {
        commit("PUT_ENTREPRISES", entreprises);
    },

    putOffersData({ commit }, offers) {
        commit("PUT_OFFERS", offers);
    },

    putProjectsData({ commit }, project) {
        commit("PUT_PROJECTS", project);
    },

    putClientsData({ commit }, clients) {
        commit("PUT_CLIENTS", clients);
    },

    SaveClients: firestoreAction(({ state, rootState, rootGetters }) => {
        db.collection("bpis")
            .doc(`${rootState.user.bpiId}`)
            .update({
                clients_info: state.clients,
                current_step: rootGetters["user/getLastStep"](
                    "Taille et évolution du marché"
                ),
                current_Substep: rootGetters["user/getLastSubStep"](
                    "Installations techniques"
                )
            })
            .then(() => {});
    }),
    SaveEntreprise: firestoreAction(({ state, rootState, rootGetters }) => {
        if (
            !isEmpty(
                rootState.EtudeFinanciere
                    .programmeDinvestissementPlanDeFinancement
            )
        ) {
            store.dispatch(
                "EtudeFinanciere/saveEditedInvestorsProgrammeCapitalSocial"
            );
        }

        db.collection("bpis")
            .doc(`${rootState.user.bpiId}`)
            .update({
                entreprise_info: state.entreprise,

                current_step: rootGetters["user/getLastStep"]("Votre projet"),
                current_Substep: rootGetters["user/getLastSubStep"](
                    "Votre Projet"
                )
            })
            .then(() => {});
    }),
    SaveProject: firestoreAction(({ state, rootState, rootGetters }) => {
        db.collection("bpis")
            .doc(`${rootState.user.bpiId}`)
            .update({
                project_info: state.project,

                current_step: rootGetters["user/getLastStep"]("Votre projet"),
                current_Substep: rootGetters["user/getLastSubStep"](
                    "Votre Offres"
                )
            })
            .then(() => {});
    }),

    SaveOffers: firestoreAction(({ state, rootState, rootGetters }) => {
        db.collection("bpis")
            .doc(`${rootState.user.bpiId}`)
            .update({
                offers: state.offers,
                current_step: rootGetters["user/getLastStep"]("Votre projet"),
                current_Substep: rootGetters["user/getLastSubStep"](
                    "Vos Clients"
                )
            })
            .then(() => {});
    })
};
